module.exports = __webpack_public_path__ + "assets/fixed.3f9fb589.svg";